import { motion } from "framer-motion";

export default function VideoIntro() {
  return (
    <section
      id="video-intro"
      data-testid="video-intro-section"
      className="relative bg-white pt-14 pb-10 lg:pt-20 lg:pb-14"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          {/* Left: video — 25% smaller than before (max ~75% of column on desktop) */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="w-full lg:max-w-[75%] border border-slate-200 bg-slate-900 overflow-hidden shadow-sm"
          >
            <video
              data-testid="intro-video"
              src="/media/intro.mp4"
              controls
              playsInline
              preload="metadata"
              className="w-full h-auto block bg-black"
            >
              Your browser does not support the video tag.
            </video>
          </motion.div>

          {/* Right: message */}
          <motion.blockquote
            data-testid="intro-message"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="w-full border-l-2 border-teal-600 pl-6"
          >
            <p
              className="font-pub italic text-slate-700 leading-relaxed"
              style={{ fontSize: "clamp(0.95rem, 1.4vw, 1.35rem)" }}
            >
              Just because a specific parameter, attribute, or scenario is not explicitly mentioned in a guidance
              document does not mean that grey area is exempted from control. The responsibility lies with us, as
              professionals, to apply sound judgement and ensure quality and compliance in those areas.
            </p>
          </motion.blockquote>
        </div>
      </div>
    </section>
  );
}
